class Toolbar extends HTMLElement {
  constructor() {
    if (
      (super(),
      (this.stickyBounds = document
        .getElementById("CollectionProductGrid")
        .querySelector(".productListing")),
      this.queryParams(),
      this.closeModalClick(),
      this.querySelector("[data-view-as]"))
    ) {
      (this.mediaView = this.querySelector("[data-view-as]")),
        (this.mediaViewMobile = this.querySelector("[data-view-as-mobile]")),
        this.mediaView.querySelectorAll(".icon-mode").forEach((e) => {
          e.addEventListener("click", this.onClickModeButtonHandler.bind(this));
        }),
        this.mediaViewMobile.querySelectorAll(".icon-mode").forEach((e) => {
          e.addEventListener(
            "click",
            this.onClickModeButtonMobileHandler.bind(this)
          );
        }),
        (this.debouncedOnResizeMediaQuery = debounce(() => {
          this.setActiveViewModeMediaQuery(!1);
        }, 200));
      var e = window.innerWidth;
      window.addEventListener("resize", () => {
        window.innerWidth != e &&
          ((e = window.innerWidth), this.debouncedOnResizeMediaQuery());
      }),
        window.addEventListener("load", () => {
          this.debouncedOnResizeMediaQuery();
        });
    }
    if (
      (this.querySelector("[data-limited-view]") &&
        ((this.limitView = this.querySelector("[data-limited-view]")),
        this.limitView
          .querySelectorAll("[data-limited-view-item]")
          .forEach((e) => {
            e.addEventListener(
              "click",
              this.onClickLimitButtonHandler.bind(this)
            );
          })),
      this.querySelector("[data-toggle]") &&
        (this.querySelectorAll("[data-toggle]").forEach((e) => {
          e.addEventListener(
            "click",
            this.onClickDropdownButtonHandler.bind(this)
          );
        }),
        document.body.addEventListener(
          "click",
          this.onBodyClickEvent.bind(this)
        )),
      this.querySelector("[data-sorting]"))
    ) {
      this.sortBys = this.querySelectorAll("[data-sorting]");
      let t = null != this.sortBys[0].querySelector("[data-sort-by-item]");
      t &&
        this.sortBys.forEach((e) => {
          e.querySelectorAll("[data-sort-by-item]").forEach((e) => {
            e.addEventListener(
              "click",
              this.onClickSortByButtonHandler.bind(this)
            );
          });
        });
    }
    this.checkNeedToConvertCurrency() &&
      Currency.convertAll(
        window.shop_currency,
        $("#currencies .active").attr("data-currency"),
        "span.money",
        "money_format"
      );
  }
  queryParams() {
    if (((Shopify.queryParams = {}), location.search.length > 0))
      for (
        var e, t = 0, i = location.search.substr(1).split("&");
        t < i.length;
        t++
      )
        (e = i[t].split("=")).length > 1 &&
          (Shopify.queryParams[decodeURIComponent(e[0])] = decodeURIComponent(
            e[1]
          ));
  }
  createURLHash(e) {
    var t = $.param(Shopify.queryParams).replace(/%2B/g, "+");
    return e
      ? "" != t
        ? e + "?" + t
        : e
      : "" != t
      ? location.pathname + "?" + t
      : location.pathname;
  }
  updateURLHash(e) {
    delete Shopify.queryParams.page;
    var t = this.createURLHash(e);
    history.pushState({ param: Shopify.queryParams }, t, t);
  }
  checkNeedToConvertCurrency() {
    return (
      (window.show_multiple_currencies &&
        Currency.currentCurrency != shopCurrency) ||
      window.show_auto_currency
    );
  }
  onClickDropdownButtonHandler(e) {
    var t = e.currentTarget;
    "mobile" === t.dataset.mobile &&
      document.body.classList.add("toolbar-modal-open"),
      "false" === t.getAttribute("aria-expanded")
        ? t.setAttribute("aria-expanded", !0)
        : t.setAttribute("aria-expanded", !1);
  }
  onClickSortByButtonHandler(e) {
    e.preventDefault();
    var t = e.currentTarget;
    if (
      ((this.sortBy = t.closest("[data-sorting]")),
      !t.classList.contains("is-active"))
    ) {
      t.querySelector(".text").getAttribute("data-value");
      var i = t.querySelector(".text").getAttribute("data-href"),
        r = t.querySelector(".text").innerText;
      if (
        (null != this.sortBy.querySelector(".label-text") &&
          (this.sortBy.querySelector(".label-text").innerText = r),
        null != this.sortBy.querySelector("[data-toggle]") &&
          this.sortBy
            .querySelector("[data-toggle]")
            ?.setAttribute("aria-expanded", !1),
        this.sortBy.querySelectorAll("[data-sort-by-item]").forEach((e) => {
          e.classList.remove("is-active");
        }),
        t.classList.add("is-active"),
        "mobile" === this.sortBy.dataset.mobile)
      ) {
        let a = this.querySelector('[data-toggle][data-mobile="mobile"]');
        a.setAttribute("aria-expanded", !1),
          document.body.classList.remove("toolbar-modal-open");
      }
      if (window.show_storefront_filter) {
        let s = document.querySelector("collection-filters-form");
        (s.querySelector('[name="sort_by"]').value = i),
          s.onSubmitHandlerFromSortBy(e, s.querySelector("form"));
      } else {
        (Shopify.queryParams.sort_by = i), this.updateURLHash();
        var o = this.createURLHash();
        this.renderPage(o);
      }
    }
  }
  getSections() {
    return [
      {
        id: "main-collection-product-grid",
        section: document.getElementById("main-collection-product-grid").dataset
          .id,
      },
    ];
  }
  renderPage(e) {
    let t = this.getSections();
    document.body.classList.add("has-halo-loader"),
      t.forEach((t) => {
        this.renderSectionFromFetch(e, t);
      });
  }
  renderSectionFromFetch(e, t) {
    fetch(e)
      .then((e) => e.text())
      .then((e) => {
        let t = e;
        this.renderSidebar(t), this.renderProductGrid(t);
      });
  }
  renderSidebar(e) {
    if (document.getElementById("main-collection-filters")) {
      let t = new DOMParser()
        .parseFromString(e, "text/html")
        .getElementById("main-collection-filters").innerHTML;
      document.getElementById("main-collection-filters").innerHTML = t;
    }
  }
  renderProductGrid(e) {
    let t = new DOMParser()
      .parseFromString(e, "text/html")
      .getElementById("CollectionProductGrid")
      .querySelector(".collection").innerHTML;
    (document
      .getElementById("CollectionProductGrid")
      .querySelector(".collection").innerHTML = t),
      this.setActiveViewModeMediaQuery(!0),
      window.compare.show &&
        this.setLocalStorageProductForCompare({
          link: $("a[data-compare-link]"),
          onComplete: null,
        }),
      window.wishlist.show && this.setLocalStorageProductForWishlist(),
      window.innerWidth < 1025 &&
        window.scrollTo({
          top:
            document
              .getElementById("CollectionProductGrid")
              .getBoundingClientRect().top +
            window.pageYOffset -
            50,
          behavior: "smooth",
        }),
      document.body.classList.remove("has-halo-loader");
  }
  setLocalStorageProductForCompare(e) {
    var t = JSON.parse(localStorage.getItem("compareItem")),
      i = $("[data-product-compare-handle]");
    null !== t &&
      i.length > 0 &&
      i.each((e, i) => {
        var r = $(i),
          a = r.data("product-compare-handle");
        t.indexOf(a) >= 0
          ? (r.find(".compare-icon").addClass("is-checked"),
            r.find(".text").text(window.compare.added),
            r.find("input").prop("checked", !0))
          : (r.find(".compare-icon").removeClass("is-checked"),
            r.find(".text").text(window.compare.add),
            r.find("input").prop("checked", !1));
      });
  }
  setLocalStorageProductForWishlist() {
    var e = localStorage.getItem("wishlistItem")
      ? JSON.parse(localStorage.getItem("wishlistItem"))
      : [];
    localStorage.setItem("wishlistItem", JSON.stringify(e)),
      e.length > 0 &&
        (e = JSON.parse(localStorage.getItem("wishlistItem"))).forEach((e) => {
          this.setProductForWishlist(e);
        }),
      $("[data-wishlist-count]").text(e.length);
  }
  setProductForWishlist(e) {
    var t = JSON.parse(localStorage.getItem("wishlistItem")),
      i = $('[data-wishlist-handle="' + e + '"]');
    t.indexOf(e) >= 0
      ? i.addClass("wishlist-added").find(".text").text(window.wishlist.added)
      : i.removeClass("wishlist-added").find(".text").text(window.wishlist.add);
  }
  setActiveViewModeMediaQuery(e = !0) {
    var t = this.mediaView?.querySelector(".icon-mode.active"),
      i = this.mediaViewMobile?.querySelector(".icon-mode.active"),
      r = parseInt(t?.dataset.col),
      a = window.innerWidth;
    1 != r
      ? (document.querySelector(".sidebar--layout_vertical")
          ? a < 768
            ? (3 == r || 4 == r || 5 == r) &&
              ((r = 2),
              t.classList.remove("active"),
              i.classList.remove("active"),
              this.mediaView.querySelector(".grid-2").classList.add("active"),
              this.mediaViewMobile
                .querySelector(".grid-2")
                .classList.add("active"))
            : a <= 1100 && a >= 768
            ? (5 == r || 4 == r || 3 == r) &&
              ((r = 2),
              t.classList.remove("active"),
              i.classList.remove("active"),
              this.mediaView.querySelector(".grid-2").classList.add("active"),
              this.mediaViewMobile
                .querySelector(".grid-2")
                .classList.add("active"))
            : a < 1299 && a > 1100
            ? (5 == r || 4 == r) &&
              ((r = 3),
              t.classList.remove("active"),
              i.classList.remove("active"),
              this.mediaView.querySelector(".grid-3").classList.add("active"),
              this.mediaViewMobile
                .querySelector(".grid-3")
                .classList.add("active"))
            : a < 1700 &&
              a >= 1299 &&
              5 == r &&
              ((r = 4),
              t.classList.remove("active"),
              i.classList.remove("active"),
              this.mediaView.querySelector(".grid-4").classList.add("active"),
              this.mediaViewMobile
                .querySelector(".grid-4")
                .classList.add("active"))
          : a < 768
          ? (3 == r || 4 == r || 5 == r) &&
            ((r = 2),
            t.classList.remove("active"),
            i.classList.remove("active"),
            this.mediaView.querySelector(".grid-2").classList.add("active"),
            this.mediaViewMobile
              .querySelector(".grid-2")
              .classList.add("active"))
          : a < 992 && a >= 768
          ? (4 == r || 5 == r) &&
            ((r = 3),
            t.classList.remove("active"),
            i.classList.remove("active"),
            this.mediaView.querySelector(".grid-3").classList.add("active"),
            this.mediaViewMobile
              .querySelector(".grid-3")
              .classList.add("active"))
          : a < 1600 &&
            a >= 992 &&
            5 == r &&
            ((r = 4),
            t.classList.remove("active"),
            i.classList.remove("active"),
            this.mediaView.querySelector(".grid-4").classList.add("active"),
            this.mediaViewMobile
              .querySelector(".grid-4")
              .classList.add("active")),
        this.initViewModeLayout(r))
      : e && this.initViewModeLayout(r);
  }
  changeBannerPositions(e) {
    let t = document.getElementById("main-collection-product-grid"),
      i = [...t.querySelectorAll(".product")],
      r = i.find((e) => 1 == e.dataset.productBanner),
      a = i.find((e) => 2 == e.dataset.productBanner),
      s = i.find((e) => 3 == e.dataset.productBanner),
      o = [r, a, s],
      l = (e) => {
        let t = i.indexOf(e);
        return {
          bannerNumber: e.dataset.productBanner,
          currentIndex: t,
          originalIndex: parseInt(e.dataset.firstPosition),
        };
      },
      c = (i) => {
        let r = i.currentIndex;
        switch (e) {
          case 2:
            1 == i.bannerNumber
              ? (r = 2)
              : 2 == i.bannerNumber
              ? (r = 5)
              : 3 == i.bannerNumber && (r = 8),
              t.classList.add("banner-full-width");
            break;
          case 3:
            r = 3 == i.bannerNumber ? i.originalIndex : i.originalIndex - 1;
            break;
          case 4:
            r = i.originalIndex;
            break;
          case 5:
            r = 3 == i.bannerNumber ? i.originalIndex + 3 : i.originalIndex + 1;
            break;
          default:
            t.classList.remove("banner-full-width");
        }
        return {
          bannerNumber: i.bannerNumber,
          originalIndex: i.originalIndex,
          currentIndex: r,
        };
      },
      d = (e) => {
        let i = [...t.querySelectorAll(".product")],
          r = i[e.currentIndex],
          a = o.find((t) => t.dataset.productBanner == e.bannerNumber);
        t.insertBefore(a, r);
      },
      n = o.map(l),
      u = n.map(c);
    t.removeChild(r), t.removeChild(a), t.removeChild(s), u.forEach(d);
  }
  initViewModeLayout(e) {
    let t = document
      .getElementById("CollectionProductGrid")
      .querySelector(".productListing");
    if (t) {
      if (1 === e)
        t.classList.remove(
          "productGrid",
          "column-5",
          "column-4",
          "column-3",
          "column-2"
        ),
          t.classList.add("productList");
      else
        switch (e) {
          case 2:
            t.classList.remove(
              "productList",
              "column-5",
              "column-4",
              "column-3"
            ),
              t.classList.add("productGrid", "column-2");
            break;
          case 3:
            t.classList.remove(
              "productList",
              "column-5",
              "column-4",
              "column-2"
            ),
              t.classList.add("productGrid", "column-3");
            break;
          case 4:
            t.classList.remove(
              "productList",
              "column-5",
              "column-3",
              "column-2"
            ),
              t.classList.add("productGrid", "column-4");
            break;
          case 5:
            t.classList.remove(
              "productList",
              "column-4",
              "column-3",
              "column-2"
            ),
              t.classList.add("productGrid", "column-5");
        }
      document.querySelector(".collection-masonry") && resizeAllGridItems(),
        document.querySelector(".collection-banner-adv") &&
          this.changeBannerPositions(e);
    }
  }
  onClickModeButtonHandler(e) {
    e.preventDefault();
    var t = e.currentTarget,
      i = this.mediaView.querySelector(".icon-mode.active"),
      r = parseInt(t.dataset.col);
    t.classList.contains("active") ||
      (i.classList.remove("active"),
      t.classList.add("active"),
      this.mediaViewMobile.querySelectorAll(".icon-mode").forEach((e) => {
        parseInt(e.dataset.col) == r
          ? e.classList.add("active")
          : e.classList.remove("active");
      }),
      this.initViewModeLayout(r));
  }
  onClickModeButtonMobileHandler(e) {
    e.preventDefault();
    var t = e.currentTarget,
      i = this.mediaViewMobile.querySelector(".icon-mode.active"),
      r = parseInt(t.dataset.col);
    t.classList.contains("active") ||
      (i.classList.remove("active"),
      t.classList.add("active"),
      this.mediaView.querySelectorAll(".icon-mode").forEach((e) => {
        parseInt(e.dataset.col) == r
          ? e.classList.add("active")
          : e.classList.remove("active");
      }),
      this.initViewModeLayout(r));
  }
  onClickLimitButtonHandler(e) {
    e.preventDefault();
    var t = e.currentTarget;
    if (!t.classList.contains("is-active")) {
      var i = parseInt(t.querySelector(".text").dataset.value);
      (this.limitView.querySelector(".label-text").innerText = i),
        this.limitView
          .querySelector("[data-toggle]")
          .setAttribute("aria-expanded", !1),
        this.limitView
          .querySelectorAll("[data-limited-view-item]")
          .forEach((e) => {
            e.classList.remove("is-active");
          }),
        t.classList.add("is-active"),
        $.ajax({
          type: "POST",
          url: "/cart.js",
          dataType: "json",
          data: { "attributes[pagination]": i },
          success: function (e) {
            window.location.reload();
          },
          error: function (e, t) {
            alert($.parseJSON(e.responseText).description);
          },
        });
    }
  }
  connectedCallback() {
    (this.onScrollHandler = this.onScroll.bind(this)),
      window.addEventListener("scroll", this.onScrollHandler, !1);
  }
  disconnectedCallback() {
    window.removeEventListener("scroll", this.onScrollHandler);
  }
  onScroll() {
    let e = window.pageYOffset || document.documentElement.scrollTop,
      t = $("#CollectionProductGrid .productListing").offset().top + 100;
    if (window.innerWidth < 1025) {
      if (e > t) {
        if (
          (requestAnimationFrame(this.showSticky.bind(this)),
          document.body.classList.contains("scroll-up"))
        ) {
          var i = document.querySelector("sticky-header").offsetHeight;
          this.style.top = `${i}px`;
        } else
          document.body.classList.contains("scroll-down") &&
            (this.style.top = 0);
      } else requestAnimationFrame(this.hideSticky.bind(this));
    }
    this.currentScrollTop = e;
  }
  hideSticky() {
    this.classList.remove("show-sticky", "animate"),
      this.closeDropdownPopupSticky();
  }
  showSticky() {
    this.classList.add("show-sticky", "animate"),
      this.closeDropdownPopupSticky();
  }
  closeModalClick() {
    (this.closeMobileModal = this.querySelector(
      "[data-sorting][data-mobile] .close-mobile-modal"
    )),
      this.closeMobileModal.addEventListener("click", () => {
        let e = this.querySelector('[data-toggle][data-mobile="mobile"]');
        e.setAttribute("aria-expanded", !1),
          document.body.classList.remove("toolbar-modal-open");
      });
  }
  closeDropdownPopupSticky() {
    this.querySelector(".label-tab") &&
      this.querySelectorAll(".label-tab").forEach((e) => {
        e.setAttribute("aria-expanded", !1);
      });
  }
  onBodyClickEvent(e) {
    this.querySelector("[data-toggle]") &&
      this.querySelectorAll("[data-toggle]").forEach((t) => {
        if ("mobile" === t.dataset.mobile) {
          let i = this.querySelector("[data-sorting][data-mobile]");
          i.contains(e.target) ||
            t.contains(e.target) ||
            (t.setAttribute("aria-expanded", !1),
            document.body.classList.contains("toolbar-modal-open") &&
              document.body.classList.remove("toolbar-modal-open"));
        } else
          t.nextElementSibling.contains(e.target) ||
            t.contains(e.target) ||
            t.setAttribute("aria-expanded", !1);
      });
  }
}
customElements.define("toolbar-item", Toolbar);
